module.exports = __webpack_public_path__ + "img/task_icon1.212afb45.png";